<div class="flex flex-col justify-center items-center pt-[100px] z-10">
    <p class="font-outfit font-semibold text-3xl sm:text-4xl">know some of <span class="gradient-text">our
            projects</span></p>
    <div class="mt-[70px] p-4 sm:p-0 grid grid-cols-1 [@media(min-width:1155px)]:grid-cols-2 gap-6">
        @for (project of (projects$ | async); track $index) {
        <div class="rounded-[36px] opacity-100 bg-cover bg-center sm:w-[550px] h-[450px]" [ngStyle]="{
    'background-image':
      'linear-gradient(180deg, rgba(20,21,60,0) 0%, rgba(27,17,65,0.4) 21.15%, rgba(20,21,60,0.6) 42.79%, #14153C 100%), url(' + project.background + ')'
  }">
            <div class="flex flex-col pl-[32px] pt-[50px] pb-[35px] h-full">
                <img class="w-[112px] h-[112px] rounded-[20px]" [src]="project.logo" alt="">
                <span class="gradient-text font-semibold font-outfit text-3xl mb-[8px]">{{project.name}}</span>
                <span class="mb-[20px] flex-1 text-base w-[95%] sm:text-lg sm:w-[85%]">{{project.description}}</span>
                <app-button buttonText="read more" (clicked)="navigateTo(project.redirectUrl)"></app-button>
            </div>
        </div>
        }
    </div>
</div>